import { LocationClosureModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class LocationClosureODataRepo extends BaseODataRepository<LocationClosureModel> {
  protected baseUrl = `/OData/locationclosure`;
}

export default LocationClosureODataRepo;
